import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment, Component } from "react";
import UNSAFE_SetEnvRef from "@uie/set-env-ref";
import styled from "styled-components";
import PropTypes from "prop-types";
import { withVDSManager } from "@vds/utilities";
var propTypes = {
  /**
   * Offset positioning to account for Sticky Header
   */
  offset: PropTypes.number,
  /**
   * Child elements contained in the Sticky Header
   */
  children: PropTypes.node,
  /**
   * Boolean to determine if header is fixed to top of page
   */
  stuck: PropTypes.bool,
  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {
  offset: 0,
  stuck: false
};
var HeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "HeaderWrapper",
  componentId: "sc-1470z4g-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  top: ", "px;\n  z-index: 999;\n  width: 100%;\n"])), function (_ref) {
  var sticky = _ref.sticky;
  return sticky ? "fixed" : "relative";
}, function (_ref2) {
  var offset = _ref2.offset,
    sticky = _ref2.sticky;
  return sticky ? offset : 0;
});
var PlaceHolder = /*#__PURE__*/styled.div.withConfig({
  displayName: "PlaceHolder",
  componentId: "sc-1470z4g-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", "px;\n"])), function (_ref3) {
  var height = _ref3.height;
  return height;
});
var StickyHeader = /*#__PURE__*/function (_Component) {
  _inherits(StickyHeader, _Component);
  var _super = _createSuper(StickyHeader);
  function StickyHeader(props) {
    var _this;
    _classCallCheck(this, StickyHeader);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "refKey", UNSAFE_SetEnvRef());
    _defineProperty(_assertThisInitialized(_this), "_initiateScroll", function () {
      _this.initialTop = _this.ref.getBoundingClientRect().top + window && window.scrollY;
      _this.height = _this.ref.offsetHeight;
      window && window.addEventListener("scroll", _this._handleScroll);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleScroll", function (evt) {
      if (_this.state.sticky && _this.props.stuck) return;
      if (window && window.scrollY <= _this.initialTop - _this.props.offset && _this.state.sticky) {
        _this.setState({
          sticky: false
        });
      } else if (window && window.scrollY >= _this.initialTop - _this.props.offset && !_this.state.sticky) {
        _this.setState({
          sticky: true
        });
      } else if ( /* test ignored for below condition due to not possible to test */
      /* istanbul ignore next */

      _this.props.stuck && !_this.state.sticky) {
        _this.setState({
          sticky: true
        });
      }
    });
    _this.state = {
      sticky: _this.props.stuck
    };
    _this.ref = null;
    _this.initialTop = 0;
    _this.height = null;
    return _this;
  }
  _createClass(StickyHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.stuck) {
        this._initiateScroll();
        this.setState({
          sticky: true
        });
      } else {
        this._initiateScroll();
        this._handleScroll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window && window.removeEventListener("scroll", this._handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        offset = _this$props.offset,
        children = _this$props.children,
        id = _this$props.id,
        className = _this$props.className;
      return /*#__PURE__*/React.createElement(Fragment, null, this.state.sticky && /*#__PURE__*/React.createElement(PlaceHolder, {
        height: this.height,
        className: className
      }), /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
        id: id,
        offset: offset,
        sticky: this.state.sticky
      }, _defineProperty({}, this.refKey, function (elem) {
        return _this2.ref = elem;
      })), children));
    }
  }]);
  return StickyHeader;
}(Component);
StickyHeader.propTypes = propTypes;
StickyHeader.defaultProps = defaultProps;
export default withVDSManager(StickyHeader);